import { render, staticRenderFns } from "./FormPositionSelect.vue?vue&type=template&id=1b5325de"
import script from "./FormPositionSelect.vue?vue&type=script&lang=js"
export * from "./FormPositionSelect.vue?vue&type=script&lang=js"
import style0 from "./FormPositionSelect.vue?vue&type=style&index=0&id=1b5325de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports